import { Dispatch } from 'redux';
import { axiosInstance, request, requestConfig } from './base';
import { UploadDocResponse } from 'store/modules/models/uploadDocResponse';
import {
  CertificadoRecebiveisApiResponse,
  CadastroCertificadoRecebiveisApiRequest,
  GETInstrumentosFilterParams,
  HistoricoResponse,
  SolicitarLiquidacaoRequest,
  CommandResultTyped,
} from 'common/genericTypes';
import { errorMessages } from 'common/errorMessages.strings';
import { AditamentoDiferenca, AditamentoRevisionData } from 'components/aditamentoModal/aditamentoRevisionModal';

export const GETCertificadoRecebiveisDetalhes = async (
  dispatch: Dispatch,
  id: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<CertificadoRecebiveisApiResponse>(`${requestConfig.api}api/v1/certificados-recebiveis/${id}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCertificadosRecebiveis = async (
  dispatch: Dispatch,
  params?: GETInstrumentosFilterParams,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<CertificadoRecebiveisApiResponse>>(
        `${requestConfig.api}api/v1/certificados-recebiveis`,
        params ? { params } : undefined
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCertificadoRecebiveisByInstrumentoId = async (
  dispatch: Dispatch,
  instrumentoId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis/instrumento-financeiro/${instrumentoId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis`,
        certificadoRecebiveis
      ),
    dispatch,
    errorMessages.instrumentoFinanceiro.generic,
    stackRequest
  );
};

export const PUTCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.put<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}`,
        certificadoRecebiveis
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PutEditarCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
  justificativa: string,
  document?: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();

  if (document) fileForm.append('file', document);
  fileForm.append('justificativa', justificativa);

  const crStringfyed = JSON.stringify(certificadoRecebiveis);
  fileForm.append('instrumentoFinanceiroRequest', crStringfyed);

  return await request(
    () =>
      axiosInstance.put<CommandResultTyped<string>>(`${requestConfig.api}api/v1/certificados-recebiveis/editar/${certificadoRecebiveisId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTCertificadoRecebiveisAditamento = async (
  dispatch: Dispatch,
  crId: string,
  cr: CadastroCertificadoRecebiveisApiRequest,
  date: string,
  document: File,
  stackRequest: boolean = false
) => {
  const fileForm = new FormData();
  fileForm.append('file', document);
  fileForm.append('dataAditamento', date);
  fileForm.append('aditamento', JSON.stringify(cr));

  return await request(
    () =>
      axiosInstance.put<string>(`${requestConfig.api}api/v1/certificados-recebiveis/aditamento/${crId}`, fileForm, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTUploadDoc = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  emissionType: string,
  file: File,
  stackRequest: boolean = false
) => {
  const data = new FormData();
  data.append('file', file);
  return await request<Array<UploadDocResponse>>(
    () =>
      axiosInstance.put<Array<UploadDocResponse>>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/document`,
        data,
        {
          params: {
            emissionType,
          },
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const DELETEUploadDoc = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  certificadoRecebiveisDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.delete(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/document/${certificadoRecebiveisDocumentId}`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETCertificadoRecebiveisDocumentDownloadUrl = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  certificadoRecebiveisDocumentId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<string>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/document/${certificadoRecebiveisDocumentId}/download`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTInterOpCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveis: CadastroCertificadoRecebiveisApiRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis/transferencia-dvm`,
        certificadoRecebiveis
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTEnviarLiquidacao = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  certificadoRecebiveisSolicitarLiquidacaoRequest: SolicitarLiquidacaoRequest,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/enviar-liquidacao`,
        certificadoRecebiveisSolicitarLiquidacaoRequest
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const POSTConfirmarLiquidacaoCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  precoUnitarioLiquidacao: number,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.post<CertificadoRecebiveisApiResponse>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/confirmar-liquidacao`,
        { precoUnitario: precoUnitarioLiquidacao },
        { headers: { 'Content-Type': 'application/json' } }
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETHistoricoCertificadoRecebiveis = async (
  dispatch: Dispatch,
  certificadoRecebiveisId: string,
  stackRequest: boolean = false
) => {
  return await request(
    () =>
      axiosInstance.get<Array<HistoricoResponse>>(
        `${requestConfig.api}api/v1/certificados-recebiveis/${certificadoRecebiveisId}/historico-de-alteracoes`
      ),
    dispatch,
    undefined,
    stackRequest
  );
};

export const GETAditamentoCertificadoRecebiveis = async (dispatch: Dispatch, aditamentoId: string, stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.get<AditamentoRevisionData>(`${requestConfig.api}api/v1/certificados-recebiveis/aditamento/${aditamentoId}`),
    dispatch,
    undefined,
    stackRequest
  );
};

export const PUTAditamentoCertificadoRecebiveis = async (dispatch: Dispatch, aditamentoId: string, diferenca: AditamentoDiferenca[], stackRequest: boolean = false) => {
  return await request(
    () => axiosInstance.put<Array<AditamentoDiferenca>>(`${requestConfig.api}api/v1/certificados-recebiveis/aditamento/atualizar/${aditamentoId}`, diferenca),
    dispatch,
    undefined,
    stackRequest
  );
};